import styles from './HeaderBadge.module.scss';

const HeaderBadge = ({ color, children }) => {
    return <span className={`${styles.badge} ${color ? `${styles[color]}` : ''}`}>{children}</span>;
};

export default HeaderBadge;
